import axios from 'axios'
import tools from '@/composables/tools'

export interface BusquedaEntidad {
	id: number
	nombre: string
	nif?: string | null
	mainEmail?: string | null
	mainTlf?: string | null
}

export interface BusquedaProceso {
	id: number
	title: string
	estado?: string | null
}

export interface BusquedaIncidencia {
	id: number
	title: string
	estado?: string | null
}

export interface BusquedaGlobal {
	entidades: BusquedaEntidad[]
	procesos: BusquedaProceso[]
	incidencias: BusquedaIncidencia[]
}

const EMPTY: BusquedaGlobal = {
	entidades: [],
	procesos: [],
	incidencias: [],
}

export abstract class SearchService {
	static async buscar(q: string): Promise<BusquedaGlobal> {
		const term = q.trim()
		if (term.length < 3) {
			return EMPTY
		}

		try {
			const response = await axios.get('buscar', { params: { q: term } })
			return {
				entidades: response.data?.entidades ?? [],
				procesos: response.data?.procesos ?? [],
				incidencias: response.data?.incidencias ?? [],
			}
		} catch (error) {
			tools().toast('No se pudo completar la búsqueda', 'danger', 4000)
			return EMPTY
		}
	}
}
